import { IStorageObject } from "../../../models/imports"

export type StorageObjectVM = ReturnType<typeof createStorageObjectVm>

export function createStorageObjectVm(object: IStorageObject) {


    return {
        object,
        isFolder: object.IsFolder,
        name: object.Name,
        selected: false
    }

}
